import React, { useState } from 'react';
import Footer from '../page/Footer';
import Header from '../page/Header';
import ContactUsPage from '../page/ContactUsPage';
import JoinButton from '../buttons/JoinButton';

const ContactUs = () => {
  
  return (
    <>
    <Header/>
   
  <br/>
      <br/>
    
     
    
      
      
    <JoinButton/>
  <ContactUsPage/> 
  <Footer/>   
    </>
  );
};



export default ContactUs;
